import { isValid } from 'date-fns';

export default function isValidBirthDate(dob: any): boolean {
  if (!dob || (typeof dob !== 'string' && dob instanceof Date === false)) {
    return false;
  }
  try {
    const minYear = 1900;
    const maxYear = new Date().getFullYear();

    const date = typeof dob === 'string' ? new Date(dob) : dob;
    const isValidDate = isValid(date);
    const isValidYear =
      date.getFullYear() >= minYear && date.getFullYear() <= maxYear;
    const is18YearsOld = new Date().getFullYear() - date.getFullYear() >= 18;

    return isValidDate && isValidYear && is18YearsOld;
  } catch (e) {
    return false;
  }
}
